export enum InformationInputType {
  string = 'string',
  boolean = 'boolean',
  integer = 'integer',
  media = 'media',
  appliance = 'appliance',
  applianceTag = 'appliance_tag',
}

export enum SeverityType {
  monitor = 'monitor',
  repair = 'repair',
  safety = 'safety',
}

export type CatalogSystem = {
  id: string
  name: string
};

export interface CatalogSystemsInterface {
  [id: string]: CatalogSystem
}

export type CatalogSubsystem = {
  id: string
  name: string
};

export interface CatalogSubsystemsInterface {
  [id: string]: CatalogSubsystem
}

export type CatalogDeficiency = {
  id: string
  title: string
  detail: string
  severity: SeverityType
  keywords: string
  catalogSystemId?: string
};

export interface CatalogDeficienciesInterface {
  [id: string]: CatalogDeficiency
}

export interface CatalogDeficienciesByTeamInterface {
  [teamId: string]: CatalogDeficienciesInterface
}

export type CatalogInformation = {
  id: string
  title: string
  dataName: string
  detail: string
  description: string | null
  visualAidTitle: string | null
  visualAidKbaUrl: string | null
  visualAidImageUrl: string | null
  questionType: InformationInputType
  units: string | null
  allowsOther: boolean
  requiresLocations: boolean
  requiresMedias: number
  requiresDeficiencyCondition: string | null
  requiresLimitationCondition: string | null
  isMultiSelect: boolean
  options: string[]
};

export interface CatalogInformationsInterface {
  [id: string]: CatalogInformation
}

export type CatalogLimitation = {
  id: string
  title: string
  detail: string
  keywords: string
  catalogSystemId?: string
};

export interface CatalogLimitationsInterface {
  [id: string]: CatalogLimitation
}

export interface CatalogLimitationsByTeamInterface {
  [teamId: string]: CatalogLimitationsInterface
}

export type CatalogLocationType = {
  id: string
  groupName: string
  name: string
};

export interface CatalogLocationTypesInterface {
  [id: string]: CatalogLocationType
}

export interface BaseCatalogSystemsForCatalogSystemInterface {
  [id: string]: string[] // key: catalog_system_id, value: base_catalog_system_ids
}

export interface SubProductType {
  id: number
  name: string
}

export interface BrandType {
  id: string
  name: string
}

export interface ApplianceProductTypeInterface {
  id: string
  name: string
  subProducts: SubProductType[]
  brands: BrandType[]
}

interface ApplianceProductTypesInterface {
  [id: string]: ApplianceProductTypeInterface
}

export interface CatalogInterface {
  systems: CatalogSystemsInterface
  subsystems: CatalogSubsystemsInterface
  deficiencies: CatalogDeficienciesInterface
  deficienciesByTeam: CatalogDeficienciesByTeamInterface
  informations: CatalogInformationsInterface
  limitations: CatalogLimitationsInterface
  limitationsByTeam: CatalogLimitationsByTeamInterface
  locationTypes: CatalogLocationTypesInterface
  baseCatalogSystemsForCatalogSystem?: BaseCatalogSystemsForCatalogSystemInterface
  applianceProductTypes: ApplianceProductTypesInterface
  lastSync: number | null
}
